<template>
  <div>
    <h5>
      <div class="form-subheader"><span>Documentos</span></div>
    </h5>

    <div class="row">
      <b-table
        :fields="fields"
        :items="items"
        show-empty
        empty-text="Nenhum documento encontrado."
      >
        <template #cell(index)="data">
          <span class="centered-cell text-muted">{{ data.index + 1 }}</span>
        </template>

        <template #cell(name)="data">
          <span class="centered-cell">{{ data.value }}</span>
        </template>

        <template #cell(created_at)="data">
          <span class="centered-cell">
            {{ data.value ? formatDateTimeCustom(data.value) : '---' }}
          </span>
        </template>

        <template #cell(actions)="row">
          <div class="centered-header">
            <a
              class="text-secondary"
              @click="downloadFile(row.item)"
              v-b-tooltip.hover
              title="Download"
            >
              <i class="fas fa-download mx-1 icon-btn"></i>
            </a>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import commomsHelper from "@/mixins/commomsHelper";
import dateFormatter from "@/mixins/dateFormatter";
import policyService from "@/services/policy";

export default {
  name: "DocumentsData",
  mixins: [commomsHelper, dateFormatter],
  props: {
    endorsement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "Nº",
          tdClass: "font-6 text-center",
          thClass: "table-pretty dbo-ui centered-header",
        },
        {
          key: "name",
          label: "Nome do documento",
          tdClass: "font-6",
          thClass: "table-pretty dbo-ui centered-header",
        },
        {
          key: "created_at",
          label: "Data de criação",
          tdClass: "font-6",
          thClass: "table-pretty dbo-ui centered-header",
        },
        {
          key: "actions",
          label: "Ação",
          tdClass: "font-14",
          thClass: "table-pretty dbo-ui centered-header",
        },
      ];
    },
    items() {
      return this.endorsement.endorsement_files || [];
    },
  },
  methods: {
    downloadFile(file) {
      policyService
        .getEndorsementFile(this.endorsement.id, file.id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.openLinkTargetBlank(response.data.url);
        })
        .catch(() => {
          this.showError("Não foi possível realizar o download deste arquivo.");
        });
    },
  },
};
</script>
